import { render } from "./UserCertificateTemplate.vue?vue&type=template&id=5b8731e2&scoped=true"
import script from "./UserCertificateTemplate.vue?vue&type=script&lang=js"
export * from "./UserCertificateTemplate.vue?vue&type=script&lang=js"

import "./UserCertificateTemplate.vue?vue&type=style&index=0&id=5b8731e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8731e2"]])

export default __exports__